<template>
    <div id="voicepartbg" class="voicepartbg">
    </div>
</template>

<script>
    import { sendGaMethods } from '@/assets/js/utils/masterBuilder.js';
    import {selectSrcMethod_3} from "@/assets/js/utils/masterBuilder.js";
    import cardlistdata from '@/assets/js/data/cardlistdata'
    export default {
        mixins: [selectSrcMethod_3, sendGaMethods],
        data(){
            return{
                // isPlay:false,
                cardlistdata,
                who: "",
            }
        },
        props: {

        },
        computed:{
           
        },
       
        mounted(){
            this.cardlistdata.forEach(element => {
                element['cardinfo'].forEach(cell => {
                    if(cell["site_name"]==this.$store.state.currentwisher){
                        this.who=cell['name'];
                    }
                })
            });

        },
        components: {
        },
        methods:{
    
        },
    }
</script>

<style lang="scss" scoped>
.voicepartbg{
    position: relative;
    background-color: #1D1C1B;
    width: 100%;
    display: flex;
    flex-direction: column;
    padding-bottom: 80px;
    // @media (min-width: 768px) AND (max-width: 960px) {
    //     padding-bottom: 170px;
    // }
    // @media (min-width: 960px) {
    //     padding-bottom: 231px;
    // }
    .voicebganimate{
        position: absolute;
        width: 100%;
        height: 100%;
        img{
            width: 100%;
            height: 100%;
        }
    }
    .maintext{
        position: relative;
        width: 100%;
        padding-top: 100px;
        text-align: center;
        font-size: 20px;
        line-height: 30px;
        font-weight: bold;
        font-family: 'Noto Serif TC';
        color: #A08E33;
        @media (min-width: 768px) AND (max-width: 960px) {
            font-size: 24px;
            line-height: 34px;
            padding-top: 120px;
        }
        @media (min-width: 960px) {
            font-size: 24px;
            line-height: 34px;
            padding-top: 147px;
        }
    }
}

</style>